module.exports = __webpack_public_path__ + "img/bg_note_01.3a26b221.jpg";